// extracted by mini-css-extract-plugin
export default {"additional-equipment":"styles_additional-equipment__JKczj","additional-equipment-tooltip":"styles_additional-equipment-tooltip__CFbKU","insurance":"styles_insurance__b9Hn6"};